import {
  BiometricAuth
} from '@aparajita/capacitor-biometric-auth';

export async function getSavedDeviceAuthAvailability() {
  const info =
    await BiometricAuth.checkBiometry();

  return {
    canAuthenticate: Boolean(
      info?.isAvailable ||
      info?.deviceIsSecure
    ),
    hasBiometry: Boolean(
      info?.isAvailable
    ),
    deviceIsSecure: Boolean(
      info?.deviceIsSecure
    )
  };
}

export async function authenticateSavedDeviceLogin({
  title = 'Unlock student app',
  subtitle = 'Use fingerprint, face, or your device unlock'
} = {}) {
  try {
    await BiometricAuth.authenticate({
      reason:
        'Authenticate to use your saved login.',
      cancelTitle:
        'Use normal login',
      allowDeviceCredential: true,
      iosFallbackTitle:
        'Use device passcode',
      androidTitle:
        title,
      androidSubtitle:
        subtitle,
      androidConfirmationRequired:
        false
    });

    return true;
  } catch (err) {
    console.error(
      'Saved login authentication failed:',
      err
    );

    if (
      err?.code === 'userCancel' ||
      err?.code === 'userFallback' ||
      err?.code === 'appCancel' ||
      err?.code === 'systemCancel'
    ) {
      return false;
    }

    throw new Error(
      err?.message ||
      'Device authentication is unavailable.'
    );
  }
}